import { render, staticRenderFns } from "./PermitUserModal.vue?vue&type=template&id=34c6ee70&scoped=true&lang=pug&"
import script from "./PermitUserModal.vue?vue&type=script&lang=js&"
export * from "./PermitUserModal.vue?vue&type=script&lang=js&"
import style0 from "./PermitUserModal.vue?vue&type=style&index=0&id=34c6ee70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c6ee70",
  null
  
)

export default component.exports